import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css';
import classNames from 'classnames';

export default function EditorPrivacy({
    onChange,
    value,
    className,
    ...props
}) {
    const { t } = useTranslation();

    const formats = [
        'bold',
        'italic',
        'underline',
        'strike',
        'align',
        'list',
        'indent',
        'link',
        'clean',
    ];

    let modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '+1' }, { indent: '-1' }],
            ['link'],
            ['clean'],
        ],
        keyboard: true,
    };

    if (props?.hideToolbar) {
        modules = {
            toolbar: false,
            keyboard: true,
        };
    }

    const placeholder = props?.placeholder ?? t('PleaseSpecifyDetail');

    const triggerChange = (changedValue) => {
        if (['', '<p><br></p>'].includes(changedValue)) onChange?.('');
        else onChange?.(changedValue);
    };

    return (
        <div className={classNames(className)}>
            <ReactQuill
                theme="snow"
                defaultValue={value}
                onChange={triggerChange}
                value={value}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                className={classNames(
                    'ql-editor-privacy',
                    props?.editorClassName
                )}
                readOnly={props?.readOnly || false}
            />
        </div>
    );
}
